/**
 * Create a promise deduplicator. Sometimes separate hooks call
 * functions that are the same, and we want to deduplicate the
 * requests while keeping component/hook logic simple.
 */
export const createPromiseDedupe = <T>() => {
  const pendingRequests = new Map<string, Promise<T>>();

  return (key: string, callback: () => Promise<T>) => {
    const pendingRequest = pendingRequests.get(key);
    if (pendingRequest) {
      return pendingRequest;
    }

    const request = callback().finally(() => {
      pendingRequests.delete(key);
    });

    pendingRequests.set(key, request);

    return request;
  };
};
